import React from 'react';
import Chip from '@mui/material/Chip';

// Mirrors WEBHOOK_DELIVERY_STATUS on the server. Kept in one place so the four
// webhook screens label a delivery identically.
export const DELIVERY_STATUS = {
    PENDING: 0,
    RUNNING: 1,
    SUCCEEDED: 2,
    FAILED: 3,
};

export const DELIVERY_STATUS_OPTIONS = [
    { value: DELIVERY_STATUS.PENDING, label: 'Pending' },
    { value: DELIVERY_STATUS.RUNNING, label: 'Running' },
    { value: DELIVERY_STATUS.SUCCEEDED, label: 'Succeeded' },
    { value: DELIVERY_STATUS.FAILED, label: 'Failed' },
];

const STATUS_COLOR = {
    [DELIVERY_STATUS.PENDING]: 'default',
    [DELIVERY_STATUS.RUNNING]: 'info',
    [DELIVERY_STATUS.SUCCEEDED]: 'success',
    [DELIVERY_STATUS.FAILED]: 'error',
};

export function deliveryStatusLabel(status) {
    const option = DELIVERY_STATUS_OPTIONS.find((o) => o.value === status);
    return option ? option.label : String(status ?? '-');
}

export function DeliveryStatusChip({ status }) {
    return (
        <Chip
            size="small"
            label={deliveryStatusLabel(status)}
            color={STATUS_COLOR[status] || 'default'}
            variant={status === DELIVERY_STATUS.PENDING ? 'outlined' : 'filled'}
        />
    );
}

export function TestChip({ isTest }) {
    if (!isTest) return null;
    return <Chip size="small" label="TEST" color="warning" variant="outlined" />;
}

export function WebhookStatusChip({ status }) {
    return (
        <Chip
            size="small"
            label={status === 1 ? 'Enabled' : 'Disabled'}
            color={status === 1 ? 'success' : 'default'}
            variant={status === 1 ? 'filled' : 'outlined'}
        />
    );
}

/** A webhook is partner-scoped when its definition says so. */
export function webhookScope(webhook) {
    return webhook?.definition?.scope === 'partner' ? 'partner' : 'company';
}

export function eventNamesOf(webhook) {
    const names = webhook?.definition?.eventName;
    if (!names) return '-';
    return Array.isArray(names) ? names.join(', ') : String(names);
}

/** Compact preview for a JSON cell; the detail view shows the whole thing. */
export function previewJson(value, length = 60) {
    if (value === null || value === undefined) return '-';
    const text = typeof value === 'string' ? value : JSON.stringify(value);
    return text.length > length ? `${text.slice(0, length)}…` : text;
}

export const preStyle = {
    margin: 0,
    padding: '8px 12px',
    maxHeight: 320,
    overflow: 'auto',
    fontFamily: 'monospace',
    fontSize: 12,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-all',
    background: 'rgba(0,0,0,0.04)',
    borderRadius: 4,
    textAlign: 'left',
};
